import { isDateCurrentYear } from '../validator/is-date-current-year'

/**
 * Formats a given ISO-8601 compliant string into a human readable format only with the date (without time).
 * You can configure this function to omit the current year.
 *
 *
 * @param {Intl} intl                           - The global Modux intl helper.
 * @param {string} iso8601string                - The date to be parsed as ISO-8601 compliant string with time zone.
 * @param {boolean} [hideYearIfCurrent=false]   - Hides the year if the given ISO-8601 compliant string states the current year.
 * @returns {string|null}
 */
export function formatIso8601StringDateOnly(intl, iso8601string, hideYearIfCurrent = false) {
    if (!iso8601string || !typeof iso8601string === 'string') {
        return null
    }
    const date = new Date(iso8601string)

    const formatString = hideYearIfCurrent && isDateCurrentYear(date) ? 'dateWoYear' : 'shortDate'

    return (intl && typeof intl.formatDate === 'function' && intl.formatDate(date, formatString)) || null
}
